import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
import { withPixelLineHeight } from '../../../styles/functions.web';
import { FormControl, MenuItem, Select as SelectBase } from '@mui/material';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'column'
        },
        label: {
            color: theme.palette.default00,
            ...withPixelLineHeight(theme.typography.bodyShortRegular),
            marginBottom: '6px',
            fontSize: '16px',
            fontWeight: '500',
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyShortRegularLarge)
            }
        },
        selectContainer: {
            position: 'relative'
        },
        select: {
            backgroundColor: theme.palette.ui10,
            borderRadius: `${theme.shape.borderRadius}px`,
            width: '100%',
            ...withPixelLineHeight(theme.typography.bodyShortRegular),
            color: theme.palette.default00,
            padding: '0.5px 16px',
            paddingRight: '42px',
            border: `1px solid ${theme.palette.default00}`,
            appearance: 'none',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&:focus': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.default00}10`
            },
            '&:disabled': {
                color: theme.palette.text03
            },
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyShortRegularLarge),
                padding: '12px 16px',
                paddingRight: '46px'
            },
            '&.error': {
                boxShadow: `0px 0px 0px 2px ${theme.palette.textError}`
            }
        },
        icon: {
            position: 'absolute',
            top: '6px',
            right: '6px',
            pointerEvents: 'none',
            '& svg': {
                fill: theme.palette.default00
            },
            '&.is-mobile': {
                top: '12px',
                right: '12px'
            }
        },
        bottomLabel: {
            marginTop: theme.spacing(2),
            ...withPixelLineHeight(theme.typography.labelRegular),
            color: theme.palette.default00,
            '&.is-mobile': {
                ...withPixelLineHeight(theme.typography.bodyShortRegular)
            },
            '&.error': {
                color: theme.palette.textError
            }
        }
    };
});
const Select = ({ bottomLabel, className, disabled, error, id, label, onChange, options, value }) => {
    const { classes, cx, theme } = useStyles();
    const isMobile = isMobileBrowser();
    const handleChange = (event) => {
        const mockValue = {
            target: {
                value: event.target.value,
            },
        };
        onChange(mockValue);
    };
    return (React.createElement("div", { className: classes.container },
        label && React.createElement("label", { className: cx(classes.label, isMobile && 'is-mobile'), htmlFor: id }, label),
        React.createElement("div", { className: classes.selectContainer },
            React.createElement(FormControl, { fullWidth: true, size: "small", sx: { height: '38px' } },
                React.createElement(SelectBase, { "aria-describedby": bottomLabel ? `${id}-description` : undefined, className: cx(classes.select, isMobile && 'is-mobile', className, error && 'error'), disabled: disabled, id: id, value: `${value}`, onChange: handleChange }, options.map(option => (React.createElement(MenuItem, { sx: { fontSize: '16px', fontFamily: 'Sarabun' }, key: option.value, value: option.value }, option.label)))))),
        bottomLabel && (React.createElement("span", { className: cx(classes.bottomLabel, isMobile && 'is-mobile', error && 'error'), id: `${id}-description` }, bottomLabel))));
};
export default Select;
